/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type CartPriceTable_user$ref = any;
export type CartPriceTable_user = {
    readonly canUseNetPrice: boolean | null;
    readonly " $refType": CartPriceTable_user$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "CartPriceTable_user",
    "type": "User",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "canUseNetPrice",
            "args": null,
            "storageKey": null
        }
    ]
} as any);
(node as any).hash = 'dfb821c9eea3dc50efc2070dff47cdd0';
export default node;
